export const API_PROTOCOL = import.meta.env.VITE_API_PROTOCOL ?? 'http';
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? 'localhost';
export const API_PREFIX = import.meta.env.VITE_API_PREFIX ?? 'api';
export const API_VERSION = import.meta.env.VITE_API_VERSION ?? 'v2';

// In dev, use relative paths so Vite proxy intercepts the requests (avoids CORS).
// In prod, use full URLs (nginx or another reverse proxy handles routing).
const isDev = import.meta.env.DEV;
export const API_URL = isDev
  ? `/${API_PREFIX}/${API_VERSION}`
  : `${API_PROTOCOL}://${API_BASE_URL}/${API_PREFIX}/${API_VERSION}`;
export const METRIC_URL = isDev
  ? `/${API_PREFIX}/metric/v1`
  : `${API_PROTOCOL}://${API_BASE_URL}/${API_PREFIX}/metric/v1`;
export const GWSTAT_URL = isDev
  ? `/${API_PREFIX}/gwstat/v1`
  : `${API_PROTOCOL}://${API_BASE_URL}/${API_PREFIX}/gwstat/v1`;
export const RNC_URL = isDev
  ? `/${API_PREFIX}/v1/rnc`
  : `${API_PROTOCOL}://${API_BASE_URL}/${API_PREFIX}/v1/rnc`;

export const MQTT_HOSTNAME = import.meta.env.VITE_MQTT_HOSTNAME ?? 'localhost';
export const MQTT_PORT = Number(import.meta.env.VITE_MQTT_PORT ?? 8083);
export const MQTT_PROTOCOL = import.meta.env.VITE_MQTT_PROTOCOL ?? 'mqtt';
export const MQTT_TOPIC_PREFIX = import.meta.env.VITE_MQTT_TOPIC_PREFIX ?? 'sub/v2';
export const MQTT_PATH = import.meta.env.VITE_MQTT_PATH ?? '/mqtt';

export const ENABLE_RNC = import.meta.env.VITE_ENABLE_RNC === 'true';
export const ENABLE_POWEROFF_HISTORY = import.meta.env.VITE_ENABLE_POWEROFF_HISTORY !== 'false';
export const ENABLE_GEOLOCATION = import.meta.env.VITE_ENABLE_GEOLOCATION === 'true';
export const ENABLE_GATEWAY_STATS_INFO =
  import.meta.env.VITE_ENABLE_GATEWAY_STATS_INFO !== 'false';

export const LORA_104_ALLOWED = import.meta.env.VITE_LORA_104_ALLOWED !== 'false';
export const LORA_104_CLASS_B_ALLOWED = import.meta.env.VITE_LORA_104_CLASS_B_ALLOWED !== 'false';
export const LORA_104_CLASS_C_ALLOWED = import.meta.env.VITE_LORA_104_CLASS_C_ALLOWED !== 'false';

export const DEFAULT_PAGE_SIZE = Number(import.meta.env.VITE_DEFAULT_PAGE_SIZE ?? 50);
export const GOOGLE_MAPS_KEY = import.meta.env.VITE_GOOGLE_MAPS_KEY ?? '';
export const GOOGLE_MAPS_MAP_ID = import.meta.env.VITE_GOOGLE_MAPS_MAP_ID ?? 'DEMO_MAP_ID';
export const AI_BASE_URL = import.meta.env.VITE_AI_BASE_URL ?? '';
export const AI_ALLOWED_USERS: string[] =
  import.meta.env.VITE_AI_ALLOWED_USERS?.split(',').map((u: string) => u.trim()) ?? [];

export const PKTGEN_URL = import.meta.env.VITE_PKTGEN_URL ?? 'http://pt-ns.test:8100';
export const ENABLE_PKTGEN = import.meta.env.VITE_ENABLE_PKTGEN === 'true';
// gwbridge: UDP destination for LoRaWAN packets (distinct from the pktgen-go REST API port)
export const GWBRIDGE_HOST = import.meta.env.VITE_GWBRIDGE_HOST ?? 'localhost';
export const GWBRIDGE_PORT = Number(import.meta.env.VITE_GWBRIDGE_PORT ?? 1780);
